import Api from "@/services/Api";

export default {
  getComparativoTasasAnualPorTipoActivo(fechas = []) {
    const cleaned = Array.isArray(fechas)
      ? fechas.map((item) => String(item || "").trim()).filter(Boolean)
      : [];
    const query = cleaned.length ? `?fechas=${cleaned.join(",")}` : "";
    return Api().get(`dashboardMetricas/comparativoTasasAnualPorTipoActivo${query}`);
  },
  getComparativoTasasAnualPorTipoContrato(fechas = []) {
    const cleaned = Array.isArray(fechas)
      ? fechas.map((item) => String(item || "").trim()).filter(Boolean)
      : [];
    const query = cleaned.length ? `?fechas=${cleaned.join(",")}` : "";
    return Api().get(`dashboardMetricas/comparativoTasasAnualPorTipoContrato${query}`);
  },
  getComparativoTasasAnualPorTercero(fechas = [], options = {}) {
    const cleaned = Array.isArray(fechas)
      ? fechas.map((item) => String(item || "").trim()).filter(Boolean)
      : [];
    const params = [];
    if (cleaned.length) params.push(`fechas=${encodeURIComponent(cleaned.join(","))}`);
    if (options?.incluirTodos) params.push("incluirTodos=true");
    if (options?.tercero) params.push(`tercero=${encodeURIComponent(String(options.tercero).trim())}`);
    const query = params.length ? `?${params.join("&")}` : "";
    return Api().get(`dashboardMetricas/comparativoTasasAnualPorTercero${query}`);
  },
  getFechasComparativoTasas() {
    return Api().get("dashboardMetricas/fechasComparativoTasas");
  },
};
